import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { client } from '@authy/lib-client/trpc'

import { rootRoute } from '@/tenant/settings/root'
import { appState } from '@/appState'

export const authenticationRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/authentication',
    component: lazyRouteComponent(() => import('./Authentication'), 'Authentication'),
    loader: async ({ abortController, parentMatchPromise }) => {
        await parentMatchPromise

        const [authenticationSettings, authDomain] = await Promise.all([
            client.tenants.getTenantAuthenticationSettings.query(
                {
                    tenantId: appState.tenant!._id.toString(),
                },
                { signal: abortController.signal }
            ),
            client.tenants.authDomain.getAuthDomain.query(
                {
                    tenantId: appState.tenant!._id.toString(),
                },
                { signal: abortController.signal }
            ),
        ])

        return { authenticationSettings, authDomain }
    },
})
